import { render } from "./IndexPaiement.vue?vue&type=template&id=733485a4&scoped=true"
import script from "./IndexPaiement.vue?vue&type=script&lang=js"
export * from "./IndexPaiement.vue?vue&type=script&lang=js"

import "./IndexPaiement.vue?vue&type=style&index=0&id=733485a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733485a4"]])

export default __exports__